'use client';

import styled from '@emotion/styled';
import { Color } from '../../../styles/Color';
import LinkButton from '../../../components/common/button/LinkButton';
import { Topbar } from '../../../components/common/top-bar/Topbar';
import { PageRoutes } from '../../app/pages/domain/constants/PageRoutes';
import { ArrowForwardIcon, Css, ITheme } from '../../../ui';

export default function NotFoundPage() {
	return (
		<div>
			<title>Not Found</title>
			<Topbar />
			<NotFoundWrapper>
				<NotFoundInnerWrapper>
					<StyledPill>404</StyledPill>
					<StyledHeader>Page not found</StyledHeader>
					<StyledParagraph>
						We couldn&apos;t find the page you were looking for. Please check
						your link or
					</StyledParagraph>
					<LinkButton
						href={PageRoutes.Gateway}
						icon={<ArrowForwardIcon aria-hidden />}
						buttonType="text"
						aria-label="Navigate back to the home page"
					>
						Return to Home
					</LinkButton>
				</NotFoundInnerWrapper>
			</NotFoundWrapper>
		</div>
	);
}

const NotFoundWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	min-height: 65vh;
`;

const NotFoundInnerWrapper = styled.div`
	max-width: 280px;
`;

const StyledHeader = styled.h4<{}, ITheme>`
	color: ${({ theme }) => theme.color.secondary};
	margin-top: ${Css.pxToRem(25)};
	margin-bottom: 0;
`;

const StyledParagraph = styled.p`
	margin-bottom: ${Css.pxToRem(10)};
	line-height: 22.3px;
	letter-spacing: ${Css.pxToRem(0.64)};
`;

const StyledPill = styled.span<{}, ITheme>`
	background: ${Color.Neutral1};
	border-radius: 60px;
	gap: ${Css.pxToRem(10)};
	padding: ${Css.pxToRem(8)} ${Css.pxToRem(24)};
	font-weight: 700;
	color: ${({ theme }) => theme.color.secondary};
	letter-spacing: 0.1px;
`;
